/**
 * iter101 — Sezioni apribili nelle finestre multiple del workspace admin.
 * Ogni voce: { id, label, path }. I path corrispondono alle rotte /admin/*.
 */
export const WORKSPACE_SECTIONS = [
  { id: 'dashboard', label: 'Dashboard', path: '/admin' },
  { id: 'clienti', label: 'Clienti', path: '/admin/clienti' },
  { id: 'fornitori', label: 'Fornitori', path: '/admin/fornitori' },
  { id: 'cantieri', label: 'Cantieri', path: '/admin/cantieri' },
  { id: 'rapportini', label: 'Rapportini', path: '/admin/rapportini' },
  { id: 'presenze', label: 'Presenze', path: '/admin/presenze' },
  { id: 'buste-paga', label: 'Buste Paga', path: '/admin/buste-paga' },
  { id: 'prima-nota', label: 'Prima Nota', path: '/admin/prima-nota' },
  { id: 'finanze', label: 'Situazione Finanze', path: '/admin/finanze' },
  { id: 'ddt', label: 'DDT', path: '/admin/ddt' },
  { id: 'preventivi', label: 'Preventivi', path: '/admin/preventivi' },
  { id: 'documenti', label: 'Documenti', path: '/admin/documenti' },
  { id: 'conti-emessi', label: 'Conti Emessi', path: '/admin/conti-emessi' },
  { id: 'fatture-emesse', label: 'Fatture Emesse', path: '/admin/fatturazione/fatture-emesse' },
  { id: 'fatture-ricevute', label: 'Fatture Ricevute', path: '/admin/fatturazione/fatture-ricevute' },
  { id: 'scadenziario', label: 'Scadenziario', path: '/admin/fatturazione/scadenziario' },
  { id: 'registri-iva', label: 'Registri IVA', path: '/admin/fatturazione/registri-iva' },
  { id: 'magazzino', label: 'Magazzino', path: '/admin/magazzino' },
  { id: 'materiali-catalogo', label: 'Catalogo Materiali', path: '/admin/materiali-catalogo' },
  { id: 'bilancio', label: "Bilancio d'Esercizio", path: '/admin/bilancio' },
  { id: 'f24', label: 'Modello F24', path: '/admin/f24' },
  { id: 'preventivi-ai', label: 'Archivio', path: '/admin/archivio' },
  { id: 'operai', label: 'Operai', path: '/admin/operai' },
  { id: 'notifiche', label: 'Notifiche', path: '/admin/notifiche' },
];
